import React from 'react';
import { Sparkles } from 'lucide-react';
import { PublicSection, Reveal } from '@/components/public';

/**
 * AnswerFirstBox — the 30-40 word AIEO snippet box that sits directly
 * below the hero on every spoke. Optimized for LLM search citations
 * (Perplexity, ChatGPT, Google AI Overviews).
 *
 * `title`     — bold headline for the answer (e.g. "How Hungry Canadian Empowers Restaurants")
 * `children`  — the summary paragraph (may contain <InlineLink /> nodes)
 */
export default function AnswerFirstBox({ title, children, testId = 'answer-first-box' }) {
  return (
    <PublicSection variant="default" className="!py-10 md:!py-12" testId={`${testId}-section`}>
      <Reveal>
        <div
          data-testid={testId}
          className="bg-background border border-border border-l-4 border-l-primary p-5 md:p-7 max-w-4xl mx-auto"
        >
          <div className="flex items-center gap-2 mb-3">
            <Sparkles className="w-4 h-4 text-primary" strokeWidth={2.5} />
            <p className="text-[11px] md:text-xs font-bold uppercase tracking-[0.18em] text-primary">
              Quick Answer
            </p>
          </div>
          {title && (
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground mb-2">
              {title}
            </h2>
          )}
          <p className="text-sm md:text-base text-foreground/85 leading-relaxed">
            {children}
          </p>
        </div>
      </Reveal>
    </PublicSection>
  );
}
